import type { NitroFetchOptions, NitroFetchRequest } from "nitropack";
const server = import.meta.server;

export function $api<
    DefaultT = unknown,
    DefaultR extends NitroFetchRequest = NitroFetchRequest,
    T = DefaultT,
    R extends NitroFetchRequest = DefaultR,
    O extends NitroFetchOptions<R> = NitroFetchOptions<R>,
>(url: R, options?: O) {
    const { locale } = useI18n();
    const xsrfToken = useState<string>("xsrfToken");
    const config = useRuntimeConfig();
    const base = server ? config.apiUrl : config.public.baseUrl;

    return $fetch<T>([base, url].join("/"), {
        ...options,
        headers: {
            "CSRF-Token": xsrfToken.value,
            ...options?.headers,
        },
        query: {
            lang: locale.value,
            ...options?.query,
        },
    });
}
